import React from 'react';
import Reveal from './Reveal';
import {
  Users,
  Briefcase,
  FileText,
  Building2,
  Gavel,
  Shield,
  Banknote,
  Home,
  MessageSquare,
} from 'lucide-react';

const SERVICES = [
  {
    icon: Users,
    title: 'Rodinné právo',
    description: 'Rozvody, péče o děti, výživné, majetkové vypořádání, opatrovnictví.',
  },
  {
    icon: Briefcase,
    title: 'Pracovní právo',
    description: 'Pracovní smlouvy, výpovědi, náhrady škody, pracovněprávní spory.',
  },
  {
    icon: FileText,
    title: 'Občanské právo',
    description: 'Smlouvy, náhrady škody, dědické právo, vlastnické vztahy.',
  },
  {
    icon: Building2,
    title: 'Obchodní právo',
    description: 'Zakládání společností, obchodní smlouvy, korporátní právo.',
  },
  {
    icon: Gavel,
    title: 'Trestní právo',
    description: 'Obhajoba v trestním řízení, zastupování poškozených osob.',
  },
  {
    icon: Shield,
    title: 'Insolvenční právo',
    description: 'Oddlužení, konkurzy, insolvenční řízení, ochrana před věřiteli.',
  },
  {
    icon: Banknote,
    title: 'Vymáhání pohledávek',
    description: 'Soudní i mimosoudní vymáhání, exekuce, platební rozkazy.',
  },
  {
    icon: Home,
    title: 'Spoluvlastnictví a SJM',
    description: 'Vypořádání spoluvlastnictví, společné jmění manželů, předkupní práva.',
  },
  {
    icon: MessageSquare,
    title: 'Právní poradenství',
    description: 'Komplexní konzultace, preventivní poradenství, právní audit.',
  },
];

export default function Services() {
  return (
    <section id="služby" className="bg-paper py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal className="mb-10 max-w-2xl sm:mb-14">
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-bronze sm:text-sm">
            Oblasti působení
          </p>
          <h2 className="font-serif text-3xl text-ink sm:text-4xl">
            Právní služby
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
            Komplexní právní zastupování napříč odvětvími práva — od první
            konzultace po zastupování před soudem.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3">
          {SERVICES.map((service, idx) => (
            <Reveal key={service.title} delay={(idx % 3) * 90}>
              <div className="group h-full border border-ink/10 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-bronze/50 hover:shadow-[0_16px_32px_-20px_rgba(20,31,41,0.35)] sm:p-7">
                <div className="mb-4 flex h-10 w-10 items-center justify-center border border-bronze/30 text-bronze transition-colors duration-300 group-hover:border-bronze group-hover:bg-bronze group-hover:text-white">
                  <service.icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <h3 className="mb-2 font-serif text-xl text-ink">
                  {service.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-slate-600">
                  {service.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
